import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { selectPromotionsPolling } from '@bcraft-frontend-lib/promotions'

import { BonusPromotionStatus } from 'shared/models/Promotion'

export const usePromotionsCount = () => {
  const promotions = useSelector(selectPromotionsPolling, shallowEqual)

  const count = useMemo(
    () => promotions.filter(promo => promo.status === BonusPromotionStatus.available).length,
    [promotions],
  )

  return { count }
}
